import React, { useEffect, useState } from 'react';
import ZLChartRow from './zlChartRow';
import './main.css';
import chartBackground from './images/ZL-vs-Pendo chart.svg';

// Landing Pages Section 1D
function ZLChart(props) {
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        const chart = new Image();
        chart.src = chartBackground;
        chart.onload = () => {
            setLoaded(true);
        };
    });

    return (
        <div className="ziplyne-chart-pendo">
            <img alt="" src={chartBackground} rel="preload" />
            {loaded &&
                <div className="ziplyne-chart__content-pendo">
                    <ZLChartRow title={"Excel Integration"} checkOther={false} />
                    <ZLChartRow title={"Branching Logic"} checkOther={false} />
                    <ZLChartRow title={"Cross Platforms"} checkOther={false} />
                    <ZLChartRow title={"User Enabled Screenshots"} checkOther={false} />
                    <ZLChartRow title={"Customizable Shareable Links"} checkOther={false} />
                    <ZLChartRow title={"Connecting Guides"} checkOther={false} />
                    <ZLChartRow title={"Step Mirroring"} checkOther={false} />
                    <ZLChartRow title={"Automated Form Selection"} checkOther={false} />
                    <ZLChartRow title={"Guide Monitoring"} checkOther={false} />
                </div>
            }
        </div>
    );
}

export default ZLChart;